import { baseUrls } from "./base-url";
import { environment, environmentTest } from "./enum";

let BASE_URL_ASSESSMENT_SERVICE;
let VISITOR_SERVICE_URL;

const currentEnv = `${process.env.REACT_APP_ENVIRONMENT}`;

const baseUrl = {
  assessmentService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.ASSESSMENT_SERVICE,
    QA: baseUrls.QA.ASSESSMENT_SERVICE,
    STAGING: baseUrls.STAGING.ASSESSMENT_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.ASSESSMENT_SERVICE,
  },
};
switch (currentEnv) {
  case environment.DEVELOPMENT:
    BASE_URL_ASSESSMENT_SERVICE = baseUrl.assessmentService.DEVELOPMENT;
    VISITOR_SERVICE_URL =
      "https://insightfulplatform.blob.core.windows.net/cdn/assets/js/visitor.js?sv=2023-01-03&st=2024-08-05T06%3A39%3A14Z&se=2050-12-25T06%3A39%3A00Z&sr=c&sp=rl&sig=vA%2FPOjLXtBXbm8aaHgpuvaoVlByr%2BhaZ6Hiqxnxnapk%3D";
    break;
  case environment.QA:
    BASE_URL_ASSESSMENT_SERVICE = baseUrl.assessmentService.QA;
    VISITOR_SERVICE_URL =
      "https://insightfulplatform.blob.core.windows.net/cdn/assets/js/visitor.js?sv=2023-01-03&st=2024-08-05T06%3A39%3A14Z&se=2050-12-25T06%3A39%3A00Z&sr=c&sp=rl&sig=vA%2FPOjLXtBXbm8aaHgpuvaoVlByr%2BhaZ6Hiqxnxnapk%3D";
    break;
  case environment.STAGING:
    BASE_URL_ASSESSMENT_SERVICE = baseUrl.assessmentService.STAGING;
    VISITOR_SERVICE_URL =
      "https://insightfulplatformprod.blob.core.windows.net/cdn/assets/js/visitor.js?sv=2023-01-03&st=2024-09-21T07%3A12%3A32Z&se=2123-12-22T07%3A12%3A00Z&sr=c&sp=rl&sig=xTTTt59cNY3ET9wc3Pj%2BE%2BO27dDUc059ItsSVAKtcAw%3D";
    break;
  case environment.PRODUCTION:
    BASE_URL_ASSESSMENT_SERVICE = baseUrl.assessmentService.PRODUCTION;
    VISITOR_SERVICE_URL =
      "https://insightfulplatformprod.blob.core.windows.net/cdn/assets/js/visitor.js?sv=2023-01-03&st=2024-09-21T07%3A12%3A32Z&se=2123-12-22T07%3A12%3A00Z&sr=c&sp=rl&sig=xTTTt59cNY3ET9wc3Pj%2BE%2BO27dDUc059ItsSVAKtcAw%3D";
    break;
  default:
    BASE_URL_ASSESSMENT_SERVICE = baseUrl.assessmentService.QA;
    VISITOR_SERVICE_URL =
      "https://insightfulplatform.blob.core.windows.net/cdn/assets/js/visitor.js?sv=2023-01-03&st=2024-08-05T06%3A39%3A14Z&se=2050-12-25T06%3A39%3A00Z&sr=c&sp=rl&sig=vA%2FPOjLXtBXbm8aaHgpuvaoVlByr%2BhaZ6Hiqxnxnapk%3D";
    break;
}

export const API_CONSTANT_V2 = "api/v2";
export const API_CONSTANT = "api/v1";

export const endPoints = {
  assessmentService: {
    GET_ONE_QUESTION_PER_ASSESSMENT:
      API_CONSTANT + "/question/fetch-by-assessments",
    QUESTION_BULK_MAP: API_CONSTANT + "/question/:assessmentid/bulk-map",
    GET_USER_ANSWER_BY_ASSESSMENTATTEMPTID:
      API_CONSTANT + "/answer/user-answer/{assessmentAttemptId}",
    CREATE_USER_ANSWER: API_CONSTANT + "/answer/user-answer",
    UPDATE_USER_ANSWER: API_CONSTANT + "/answer/user-answer",
    GET_USER_ANSWER_BY_ASSESSMENTATTEMPTID_QUESTIONID:
      API_CONSTANT + "/answer/user-answer/{assessmentAttemptId}/{questionId}",
    SAVE_ASSESSMENT_RESULT:
      API_CONSTANT + "/assessment/{assessmentAttemptId}/inspect",
    GET_ASSESSMENT_RESULT:
      API_CONSTANT + "/assessment/{assessmentAttemptId}/result",
    CREATE_USER: API_CONSTANT + "/user",
    LOGIN_ATTEMPT: API_CONSTANT + "/user/login-attempt",
    GET_USER_BY_ID: API_CONSTANT + "/user/{userid}",
    CREATE_EXTERNAL_USER: API_CONSTANT + "/user/social",
    USER_LOGIN: API_CONSTANT + "/user/search",
    SEARCH_USER_BY_EMAIL_ACCOUNT_NUMBER: API_CONSTANT + "/user/search-user",
    USER_AUTH: API_CONSTANT + "/auth/user/generate-token",
    EXTERNAL_USER_AUTH: API_CONSTANT_V2 + "/auth/user/generate-token-userguid",
    GET_PLANS: API_CONSTANT + "/payment-process/plans",
    UPDATE_USERID: API_CONSTANT + "/answer/user-answer/userId",
    // GET_ASSESSMENT_ATTEMPT:
    //   API_CONSTANT +
    //   "/assessment/{assessmentId}/stage/{userGuid}/{assessmentAttemptId}",
    GET_ASSESSMENT_ATTEMPT:
      API_CONSTANT_V2 + "/assessment/{userGuid}/stage/{assessmentAttemptId}",
    GET_ASSESSMENT_ATTEMPT_BY_USERID:
      API_CONSTANT_V2 + "/assessment/{userGuid}/stage",
    CREATE_ASSESSMENT_ATTEMPT: API_CONSTANT_V2 + "/assessment/stage",
    UPDATE_ASSESSMENT_ATTEMPT: API_CONSTANT_V2 + "/assessment/stage",
    GET_ALL_ASSESSMENT_: API_CONSTANT + "/assessment",
    GET_ASSESSMENT_BY_ASSESSMENTID: API_CONSTANT + "/assessment/{assessmentId}",
    CREATE_PAYMENT_INTENT: API_CONSTANT + "/payment-process/paymentintent",
    CREATE_WALLET_PAYMENT_INTENT:
      API_CONSTANT + "/payment-process/payment-intent/wallet",
    DO_CHECKOUT: API_CONSTANT + "/payment-process",
    FORGOT_PASSWORD: API_CONSTANT + "/user/forgot-password",
    RESET_PASSWORD: API_CONSTANT + "/user/reset-password",
    CONFIRMATION:
      API_CONSTANT + "/payment-process/user/{userGuid}/confirmation",
    CHANGE_PASSWORD: API_CONSTANT + "/user/change-password",
    ACCOUNT_CANCELLATION: API_CONSTANT + "/cancel/user/{userGuid}",
    GET_TRANSACTION_DETAILS:
      API_CONSTANT +
      "/payment-process/transaction/userguid?userguid={userguid}",
    GET_BILLING:
      API_CONSTANT +
      "/payment-process/billing/{transId}/details/{skuGuid}/{locale}",
    UPDATE_USER: API_CONSTANT + "/user/details",
    GET_PAYMENT_PROCESSOR_LIST: API_CONSTANT + "/processor/all",
    UPDATE_PAYMENT_PROCESSOR: API_CONSTANT + "/processor/update",
    DOWNLOAD_ASSESSMENT_RESULT:
      API_CONSTANT + "/report/{userGuid}/download/{assessmentAttemptId}",
    VIEW_ASSESSMENT_REPORT:
      API_CONSTANT + "/report/{userGuid}/viewreport/{assessmentAttemptId}",
    GET_GUEST_USER: API_CONSTANT + "/user/{parentGuid}/guest-user",
    CREATE_GUEST_USER: API_CONSTANT + "/user/guest",
    UPDATE_GUEST_USER: API_CONSTANT + "/user/update/guest",
    DECRYPTURL: API_CONSTANT + "/user/decrypt-cipher?token={token}",
    IS_ADMIN: API_CONSTANT + "/user/is-admin",
    LOGIN_AS_ADMIN: API_CONSTANT + "/user/admin",
    IS_GUEST_OR_PREMIUM_USER:
      API_CONSTANT + "/user/{userGuid}/is-premium-guest",
    GET_LATEST_VERSION:
      API_CONSTANT +
      "/insightfulcontent/{modelType}/latest-version?contentKey={contentKey}",
    CREATE_CONTENT_MAP: API_CONSTANT + "/user/{userguid}/content-map",
    SHARE_REPORT_ON_EMAIL:
      API_CONSTANT + "/report/{userid}/result/{assessmentAttemptId}/share",
    DELETE_REPORT: API_CONSTANT_V2 + "/assessment/stage",
    CAREER_CONTENT:
      API_CONSTANT + "/assessment/{personalityId}/career-pre-content",
    GET_INSIGHTFUL_CONTENT:
      API_CONSTANT +
      "/insightfulcontent/?modelType={modelType}&contentKey={contentKey}",
    AB_TEST: API_CONSTANT + "/abtest/user/conduct",
    GET_AB_TEST: API_CONSTANT + "/abtest/{abtestId}",
    SEND_TO_FRIEND: API_CONSTANT + "/report/{userGuid}/send-to-friend",
    SEND_TO_PARTNER: API_CONSTANT + "/assessment/{userGuid}/send-to-partner",
    SEND_REFUND_REQUEST:
      API_CONSTANT + "/payment-process/refund-request/{userGuid}",
    ACCOUNT_REACTIVATE: API_CONSTANT_V2 + "/payment-process/billing/reactivate",
    BULK_ACCOUNT_REACTIVATE:
      API_CONSTANT + "/payment-process/billing/bulk/reactivate",
    USER_META: API_CONSTANT + "/payment-process/user-meta",
    UPDATE_USER_EMAIL: API_CONSTANT + "/user/email",
    CREATE_ASSESSMENT_MAP: API_CONSTANT + "/assessment/assessmentMap",
    IS_COMPLETE_ROMANTIC_COMPATIBILITY:
      API_CONSTANT +
      "/assessment/{assessmentMapId}/is-complete-romantic-compatibility",
    CREATE_GUEST_USER_WITHOUT_EMAIL: API_CONSTANT + "/user/create-guest-user",
    SAVE_RELATIONSHIP_COMPATIBILITY_RESULTS:
      API_CONSTANT +
      "/assessment/relationship-compatibility-results/{assessmentMapId}",
    USER_ASSESSMENT_RESULT_MAP: API_CONSTANT + "/assessment/result-maps",
    GET_USER_ASSESSMENT_RESULT_MAP:
      API_CONSTANT + "/assessment/result-maps/{userId}",
    GET_USER_ASSESSMENT_RESULT_BY_RESULT_ID:
      API_CONSTANT + "/assessment/result/{id}",
    UPDATE_USER_PASSWORD: API_CONSTANT + "/user/update-password",
    GET_ALL_BADGES: API_CONSTANT + "/assessment/badges",
    SAVE_USER_SOCIAL_BUTTON_CLICK: API_CONSTANT + "/user/user-button-click",
    GET_USER_SOCIAL_BUTTON_CLICK_BY_USER_ID:
      API_CONSTANT + "/user/user-button-click?userId={userId}",
    VERIFY_CAPCHA_TOKER: API_CONSTANT + "/captcha/verify?portal={portal}",
    UPDATE_USER_PLAN: API_CONSTANT + "/payment-process/downgrade",
    CANCELLATION_FEEDBACK: API_CONSTANT + "/cancel/cancellation-feedback",
    GET_ORDER_DATA_BY_USERID: API_CONSTANT + "/order/user/{userId}",
    SURVEY_FEEDBACK: API_CONSTANT + "/user/survey-feedback",
    PAYPAL_ACCESS_TOKEN:
      API_CONSTANT + "/payment-process/{userguid}/paypal-access-token",
    CREATE_HMAC: API_CONSTANT + "/payment-process/hmac",
  },
};
const getBaseUrl = (baseUrl) => {
  return (endPoint) => {
    return `${baseUrl}${endPoint}`;
  };
};

export const getAssessmentServiceEndPoint = getBaseUrl(
  BASE_URL_ASSESSMENT_SERVICE,
);

export const getVisitorServiceUrl = getBaseUrl(VISITOR_SERVICE_URL);
